import React, { useState } from 'react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel } from '@components/ui/dropdown-menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DropdownActionMenu = ({
  items,
  trigger,
  triggerProps,
  contentProps,
  menuTitle
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const renderTrigger = () => {
    if (typeof trigger === 'function') {
      return trigger(openMenu);
    }
    return trigger;
  };
  return /*#__PURE__*/_jsxs(DropdownMenu, {
    open: openMenu,
    onOpenChange: setOpenMenu,
    children: [/*#__PURE__*/_jsx(DropdownMenuTrigger, {
      asChild: true,
      ...triggerProps,
      children: renderTrigger()
    }), /*#__PURE__*/_jsxs(DropdownMenuContent, {
      align: "end",
      ...contentProps,
      children: [menuTitle && /*#__PURE__*/_jsx(DropdownMenuLabel, {
        children: menuTitle
      }), items.map((item, index) => /*#__PURE__*/_jsx(DropdownMenuItem, {
        onClick: e => {
          item.onClick(e);
        },
        selected: item.selected,
        disabled: item.disabled,
        className: item.className,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2",
          children: [item.icon, item.label]
        })
      }, index))]
    })]
  });
};
export default DropdownActionMenu;